import { ComponentProps } from 'react'

import { DataSharingLegalText } from '@cash-web/grant-flow-ui-shared'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { PinInput } from '@cash-web/shared-feature-form'

import { BaseBlocker, SubmitButton } from '../BaseBlocker/BaseBlocker'

export type BlockerPasscodeEntryProps = {
  length: number
  name: string
  onSubmit: (passcode: string) => void
} & Omit<ComponentProps<typeof BaseBlocker>, 'onSubmit'>

export const BlockerPasscodeEntry = ({ length, name, onSubmit, buttons = [], ...rest }: BlockerPasscodeEntryProps) => {
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  if (isArcadeMigrationEnabled) {
    return (
      <BaseBlocker
        onSubmit={onSubmit}
        buttons={buttons.length === 0 ? [<SubmitButton key="submit-passcode" />] : buttons}
        {...rest}
      >
        <DataSharingLegalText />
        <PinInput name={name} pinLength={length} onComplete={onSubmit} />
      </BaseBlocker>
    )
  }

  return (
    <BaseBlocker onSubmit={onSubmit} buttons={buttons} {...rest}>
      <DataSharingLegalText />
      <PinInput name={name} pinLength={length} onComplete={onSubmit} />
    </BaseBlocker>
  )
}
